export default class StepHeader {
  public header: string = '';

  public subHeader: string = '';

  public topic: string = '';
}
